(function () {
  const squarePlacementSelector = 'square-placement';
  const afterpayParagraphSelector = 'afterpay-paragraph, .afterpay-paragraph';
  const observedShadowRoots = new WeakSet();

  const partTargets = [
    {
      selector: afterpayParagraphSelector,
      part: 'afterpay-paragraph',
    },
    {
      selector: 'afterpay-main-text, .afterpay-main-text',
      part: 'afterpay-main-text',
    },
    {
      selector: 'afterpay-logo, .afterpay-logo',
      part: 'afterpay-logo',
    },
    {
      selector: 'svg',
      part: 'afterpay-logo-svg',
    },
    {
      selector: '.afterpay-logo-badge-lockup',
      part: 'afterpay-logo-badge-lockup',
    },
    {
      selector: '.afterpay-logo-badge-lockup path',
      part: 'afterpay-logo-badge-lockup-path',
    },
  ];

  /**
   * @param {Element} element
   * @param {string} part
   */
  function addPart(element, part) {
    const currentParts = element.getAttribute('part')?.split(/\s+/).filter(Boolean) ?? [];

    if (currentParts.includes(part)) return;

    currentParts.push(part);
    element.setAttribute('part', currentParts.join(' '));
  }

  /**
   * @param {ShadowRoot} shadowRoot
   */
  function exposeAfterpayParts(shadowRoot) {
    if (!shadowRoot.querySelector(afterpayParagraphSelector)) return;

    for (const { selector, part } of partTargets) {
      const elements = shadowRoot.querySelectorAll(selector);

      for (const element of elements) {
        addPart(element, part);
      }
    }
  }

  /**
   * @param {ShadowRoot | null} shadowRoot
   */
  function observeShadowRoot(shadowRoot) {
    if (!shadowRoot) return;

    if (observedShadowRoots.has(shadowRoot)) return;

    observedShadowRoots.add(shadowRoot);
    exposeAfterpayParts(shadowRoot);

    const observer = new MutationObserver(() => {
      exposeAfterpayParts(shadowRoot);
    });

    observer.observe(shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  function exposeSquarePlacementParts() {
    const placements = document.querySelectorAll(squarePlacementSelector);

    for (const placement of placements) {
      observeShadowRoot(placement.shadowRoot);
    }
  }

  function startAfterpayPartObserver() {
    exposeSquarePlacementParts();

    const documentObserver = new MutationObserver(() => {
      exposeSquarePlacementParts();
    });

    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    let attempts = 0;
    const retry = () => {
      exposeSquarePlacementParts();
      attempts += 1;

      if (attempts < 60) {
        window.setTimeout(retry, 250);
      }
    };

    retry();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAfterpayPartObserver, { once: true });
  } else {
    startAfterpayPartObserver();
  }
})();
